import _ from 'lodash'
import { extendsPage } from './extends-page'
import { withI18n } from './withI18n'
import { withRedux } from './withRedux'
import { withExtendsPageConfig } from './internal/withExtendsPageConfig'

export function withPage(createConfig) {
  return function (Component) {
    let pageConfig = {}
    let middleware = []

    if (createConfig) {
      // withPage 仅提供 withI18n, withRedux 两个。其余自行引入
      // [object, function, function, ...]
      // [function, function, ...]
      const createResult = createConfig({ withI18n, withRedux })
      if (createResult.length > 0) {
        if (typeof createResult[0] === 'function') {
          middleware = createResult
        } else {
          ;[pageConfig, ...middleware] = createResult
        }
      }
    }

    if (!_.isPlainObject(pageConfig)) {
      console.error(pageConfig)
      throw new Error('pageConfig 必须为普通对象')
    }

    let TargetComponent = Component

    // withExtendsPageConfig 作为第一个生效的中间件，以便使用业务注入的中间件
    TargetComponent = withExtendsPageConfig(pageConfig)(Component)

    // 应用 middleware
    middleware.forEach((m) => {
      if (typeof m !== 'function') {
        console.error(m)
        throw new Error(
          '返回值的从第二个元素开始，需为 function 形式的装饰器中间件'
        )
      }
      TargetComponent = m(TargetComponent)
    })

    // 劫持 getInitialProps，实现标记 withPage
    const pageGetInitialPropsRef = TargetComponent.getInitialProps
    TargetComponent.getInitialProps = async function (ctx) {
      let pageInitialProps
      if (pageGetInitialPropsRef) {
        pageInitialProps = await pageGetInitialPropsRef.call(
          TargetComponent,
          ctx
        )
      }
      return {
        ...pageInitialProps,
        __AL_EX_PAGE_IDENTITY_Ia4TZzV7F1x12Jp3:
          'd3b5fa5f-860d-4d66-8cf6-594e21a72873',
      }
    }

    TargetComponent = extendsPage(pageConfig, TargetComponent)

    return TargetComponent
  }
}
